<template>
    <div class="ls_slidelist" :class="{ disabled: $props.disabled === true }">
        <div class="ls_slide"
            v-for="(item, index) in slides"
            :key="index">

            <div v-if="item.type=='img'" class="ls_item">
                <div class="html">
                    <img :src="item.url" alt="">
                </div>
                <a @click="remove(index)"><i class="material-icons">close</i></a>
            </div>

            <div v-else class="ls_item">
                <div class="html">
                    <iframe 
                        width="400" height="200" 
                        :src="'https://www.youtube.com/embed/' + item.url" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
                        allowfullscreen></iframe>
                </div>
                <a @click="remove(index)"><i class="material-icons">close</i></a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [ 'disabled' ],
    data: function()
    {
        return {
            slides: [],
        }
    },
    created: function()
    {
        this.slides = this.$attrs.value;
    },
    watch: {
        '$attrs.value': function()
        {
            this.slides = this.$attrs.value;
        }
    },
    methods: {
        remove: function( index )
        {
            if(this.$props.disabled === true) return;
            this.slides = this.slides.filter( (elem,idx) => (index!=idx) );
            this.$emit('input', this.slides);
        }
    }
}
</script>

<style lang="scss">
.ls_slidelist {
    height: 263px;
    overflow-y: scroll;

    &.disabled {
        opacity: .4;
    }

    .ls_slide {
        margin-right: 8px;
    }

    .ls_item {
        padding-bottom: 5px;
        display: flex;

        & > a {
            background: #eee;
            height: 200px;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .html img {
        width: 400px;
        height: 200px;
        object-fit: cover;
    }
}
</style>
